// extracted by mini-css-extract-plugin
export default {"root":"lybauLfF7i6yuui7SRZPo"};